import React from "react";
import banner from "../../assets/projects/leadflowbanner.jpg";
import ss1 from "../../assets/screenshots/leadflow/leadcapture.png";
import ss2 from "../../assets/screenshots/leadflow/qgenerator.png";
import ss3 from "../../assets/screenshots/leadflow/salesprocessai.png";

const LeadFlowPage = () => (
  <main className="container mx-auto max-width pt-10 pb-20 space-y-16">
    {/* Banner Image */}
    <section className="w-full">
      <img
        src={banner}
        alt="LeadFlow Banner"
        className="w-[500px] rounded-xl shadow-md object-cover"
      />
    </section>

    {/* Project Title & Overview */}
    <section>
      <h1 className="text-4xl xl:text-5xl font-bold text-dark-heading dark:text-light-heading mb-4">
        LeadFlow
      </h1>
      <p className="text-lg text-content lg:max-w-4xl">
        LeadFlow is an end-to-end AI-powered lead qualification and sales automation system built using n8n, ChatGPT, Airtable, Supabase, Jotform, and Gmail. It intelligently captures leads from multiple channels, dynamically generates personalized qualification forms using AI, evaluates responses to determine lead quality, and automatically assigns the right sales agent. This ensures higher conversion rates, efficient agent utilization, and seamless lead management.
      </p>
    </section>

    {/* Technology Stack */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        💻 Technology Stack
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li><strong>n8n:</strong> Core automation workflows and orchestration of all integrations</li>
        <li><strong>ChatGPT:</strong> AI agents for lead scoring, question generation, and qualification analysis</li>
        <li><strong>Airtable:</strong> Main database to manage leads, qualification status, and agent assignments</li>
        <li><strong>Supabase:</strong> Used for additional data storage and logging</li>
        <li><strong>Gmail Integration:</strong> Fetches email leads and sends personalized email notifications</li>
        <li><strong>Jotform:</strong> Automatically generates and sends qualification forms to leads</li>
      </ul>
    </section>

    {/* Core Features */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        ⚡ Core Features
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li>Multi-channel lead capture: email (Gmail), chat (n8n trigger), and form submissions</li>
        <li>AI-powered lead classification to determine potential leads from messages</li>
        <li>Automatic Airtable lead creation and real-time status updates</li>
        <li>Dynamic AI-generated qualification forms (via Jotform API)</li>
        <li>Automated lead qualification analysis using AI based on form responses</li>
        <li>Intelligent sales agent assignment and instant email notification to agents</li>
      </ul>
    </section>

    {/* Project Flow */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        🔄 Full Project Flow
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li><strong>Lead Capture Workflow:</strong> Captures leads from Gmail, chat, and forms. AI classifies incoming messages; potential leads are added to Airtable and trigger the form generation workflow.</li>
        <li><strong>Lead Qualification Form Generation:</strong> Questions Generator AI agent creates 4–5 tailored questions; these are built into Jotform via API. The form link is then emailed to the lead.</li>
        <li><strong>Lead Qualification Form Submitted:</strong> Once submitted, Lead Qualification AI analyzes responses and updates Airtable with qualified status. The system then assigns an agent and sends an email notification to the selected sales agent.</li>
      </ul>
    </section>

    {/* Screenshots */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        🖼️ Project Images & Screenshots
      </h2>
      <div className="flex flex-col gap-6">
        <div>
          <p className="mb-2 font-medium">Multiple-Channel Lead Capture Workflow (n8n)</p>
          <a href={ss1} target="_blank" rel="noopener noreferrer">
            <img src={ss1} alt="Lead Capture Workflow" className="w-full rounded-lg shadow" />
          </a>
        </div>
        <div>
          <p className="mb-2 font-medium">AI Question & Form Generation Workflow (n8n)</p>
          <a href={ss2} target="_blank" rel="noopener noreferrer">
            <img src={ss2} alt="Question Generator" className="w-full rounded-lg shadow" />
          </a>
        </div>
      
        <div>
          <p className="mb-2 font-medium">Lead Qualification Analysis & Sales Assignment Workflow (n8n)</p>
          <a href={ss3} target="_blank" rel="noopener noreferrer">
            <img src={ss3} alt="Qualification Analysis" className="w-full rounded-lg shadow" />
          </a>
        </div>
      
      </div>
    </section>
  </main>
);

export default LeadFlowPage;
